import { OnInit, OnDestroy, Component } from "@angular/core";
import { Subscription } from "rxjs";
import { eScreenSize } from "src/app/@shared/enums/screen-size.enum";
import { ResizeService } from "src/app/@shared/services/resize/resize.service";

@Component({
    template: '',
    standalone: false
})
export abstract class ResizeableComponent implements OnInit, OnDestroy {
    protected isDesktop: boolean
    protected isLaptop: boolean
    protected isMobile: boolean

    private resizeSubscriber: Subscription;

    constructor(protected resizeService: ResizeService) {

    }

    ngOnDestroy(): void {
        this.resizeSubscriber?.unsubscribe();
    }

    ngOnInit(): void {
        this.resizeSubscriber = this.resizeService.onResize$.subscribe((size) => {
            this.isDesktop = this.resizeService.isDesktop;
            this.isMobile = this.resizeService.isMobile;
            this.isLaptop = size >= eScreenSize.XL && size < eScreenSize.XXL;
        })
    }
}